import { defineAsyncComponent } from "vue";
import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized,
} from "vue-router";
import LoadingSpinner from "@two-ui/components/LoadingSpinner.vue";
import AuthLogin from "@two-ui/views/AuthLogin.vue";

export function initShopManagementRoutes() {
  return [
    {
      path: "/",
      redirect: "/shop-management",
    },
    {
      path: "/login",
      component: AuthLogin,
      name: "auth-login",
      meta: { preAuth: true },
    },
    {
      path: "/shop-management",
      name: "shop-management",
      component: async () =>
        defineAsyncComponent({
          loader: () => import("./views/BasePage.vue"),
          loadingComponent: LoadingSpinner,
        }),
      children: subRoutesShopManagement,
      meta: { requiresCustomerId: true },
    },
  ];
}

export const subRoutesShopManagement = [
  {
    path: "banners",
    name: "banners-home",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/BannersHome.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      breadCrumbTitle: "Banners",
    },
  },
  {
    path: "featured",
    name: "featured-products-home",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/FeaturedProductsHome.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      breadCrumbTitle: "Featured",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (from.meta.scrollTopOnLeave || to.meta.scrollTopOnEnter)
      return {
        top: 0,
        left: 0,
      };
    else if (savedPosition) return savedPosition;
  },
  routes: initShopManagementRoutes(),
});

router.beforeEach(
  (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    // pass query params to route
    if (to.meta.keepParams) {
      const hasQueryStringsFrom = !!Object.keys(from.query).length;
      const hasQueryStringsTo = !!Object.keys(to.query).length;

      if (!hasQueryStringsTo && hasQueryStringsFrom) {
        return { name: to.name!, query: from.query };
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
);

export default router;
